/* 孫吳傳・第 6 章：神亭（曲阿附近，195 年）
 * 西邊是孫策渡江後的營地，東邊是劉繇的營；中間一條大路，路上有劉繇的哨兵來回巡邏。
 * 神亭在北邊的嶺上，嶺頂是一片空地（單挑就在這裡），四周是岩丘；從營地往北繞，沿路有草叢可以躲過哨兵。
 * 南邊有一個小村，村裡有商舖。 */
export default {
  id: 'shenting', name: '神亭', W: 7600, H: 5200, seed: 195,
  bases: [[900, 2900], [6800, 2500]], // 孫策營、劉繇營
  roads: [
    { pts: [[900, 2900], [2100, 3050], [3300, 2950], [4500, 2800], [5700, 2600], [6800, 2500]], w: 160 }, // 大路：哨兵在這條路上巡邏
    { pts: [[3300, 2950], [3600, 2450], [3850, 1950]], w: 110 }, // 嶺下的小路：從大路上神亭
    { pts: [[2100, 3050], [2500, 3800], [3100, 4300]], w: 110 }, // 往南邊的村子
    { pts: [[900, 2900], [1300, 2100], [2100, 1500], [2900, 1350], [3500, 1500]], w: 90 }, // 北邊的樵徑：繞過大路，沿路有草
  ],
  rocks: [
    [3350, 1100, 360, 170], [4500, 1150, 380, 180], [4750, 1800, 220, 150], [3050, 2150, 200, 120], // 神亭嶺四周的岩丘
    [1700, 900, 420, 200], [6200, 1100, 500, 240], [5600, 4300, 420, 220], [1300, 4400, 360, 200], [4300, 3900, 260, 150],
  ],
  woods: 0.42,
  sight: 0.7,
  clearings: [[3950, 1750, 520], [2900, 1350, 200]],
  fields: [[2700, 4500, 560, 280], [3600, 4650, 480, 260, '#86803f'], [1500, 3600, 480, 260]],
  villages: [{ x: 3100, y: 4300, n: 6, r: 440 }],
  shops: [[3250, 4250]],
  tents: [{ x: 900, y: 2900, n: 8, r: 420 }, { x: 6800, y: 2500, n: 10, r: 480, chief: true }],
  marsh: [[5200, 3500, 360, 160]],
  grass: [
    [1500, 1950, 260, 120], [2150, 1700, 300, 130], [2650, 1550, 240, 110], [3300, 1600, 220, 100], // 樵徑旁：躲哨兵
    [2700, 2600, 240, 110], [4400, 2350, 260, 110], [5300, 2300, 240, 110], [1900, 3600, 260, 120], [4800, 3300, 240, 110],
  ],
};
